// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Materialtransport } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useDeleteMaterialtransport(): (
  taetigkeitsberichtId: string,
  fuhrparkeintragId: string,
  materialtransportId: string
) => Promise<Materialtransport> {
  const getAPI = useGetApi();
  return useCallback(
    async (taetigkeitsberichtId, fuhrparkeintragId, materialtransportId) =>
      (await getAPI()).materialtransporte.deleteMaterialtransport({
        taetigkeitsberichtId,
        fuhrparkeintragId,
        materialtransportId,
      }),
    [getAPI]
  );
}
